
import Dom_ from '../utility/dom';
import * as math from '../../utils/math';

//get rid of compiler mess
var dom = Dom_;


var ControlModeMapObserver = function(browser) {
    this.browser = browser;
    this.config = browser.config;

    this.coordsDeltas = [];
    this.panning = false;
    this.orientationDeltas = [];
    this.viewExtentDeltas = [];
    this.northResetAnimation = false;

    this['drag'] = this.drag;
    this['up'] = this.up;
    this['wheel'] = this.wheel;
    this['tick'] = this.tick;
    this['reset'] = this.reset;
    this['keyup'] = this.keyup;
    this['keydown'] = this.keydown;
    this['keypress'] = this.keypress;
    this['doubleclick'] = this.doubleclick;

    this.retinaFactor = 1.0 / Math.max(1.0,(window.devicePixelRatio || 1) - 1);
};


ControlModeMapObserver.prototype.drag = function(event) {
    var map = this.browser.getMap();
    if (!map) {
        return;
    }

    var camera = map.outerMap.camera;
    var coords = camera.center;
    var delta = event.getDragDelta();
    //var zoom = event.getDragZoom();
    var touches = event.getDragTouches();
    var azimuthDistance = this.getAzimuthAndDistance(delta[0], delta[1]);
    var sensitivity, config = this.config;

    var modifierKey = (this.browser.controlMode.altKey
               || this.browser.controlMode.shiftKey
               || this.browser.controlMode.ctrlKey);

    //event.getTouchParameter("touchMode");


    if (touches == 2) {//} && /*event.getDragButton("middle")*/ zoom != 0 && this.config.zoomAllowed) {
        if (event.getTouchParameter('touchMode') == 'pan' && config.rotationAllowed) {

            sensitivity = config.sensitivity[1] * this.retinaFactor;
            this.orientationDeltas.push([delta[0] * sensitivity,  -delta[1] * sensitivity, 0]);
            this.browser.map.emit('map-position-rotated', {});

        } else if (event.getTouchParameter('touchMode') == 'zoom' && config.zoomAllowed) {

            var delta = event.getTouchParameter('touchDistanceDelta');

            if (Math.abs(delta) >= 1) {

                var factor = 1.0 + (delta > 0 ? -1 : 1)*0.01;
                this.viewExtentDeltas.push(factor);
                this.reduceFloatingHeight(0.8);

                if (config.legacyInertia) {
                    this.updateDeltas(false, false, true);
                }

                this.browser.map.emit('map-position-zoomed', {});
            }
        }

    } else if ((event.getDragButton('left') && !modifierKey) && config.panAllowed) { //pan

        // panning follows the terrain: the first drag re-references
        // the altitude, the following ones move the center
        this.panning = true;

        if (camera.altitudeRef == 'datum') {
            camera.setAltitudeRef('terrain');
            this.applyLimits();
        } else {
            sensitivity = config.sensitivity[0] * this.retinaFactor;
            var fov = camera.fovy;
            var fovCorrection = (fov > 0.01 && fov < 179) ? (1.0 / Math.tan(math.radians(fov*0.5))) : 1.0;
            var azimuth = math.radians(azimuthDistance[0]);
            var forward = [Math.sin(azimuth), //direction vector x
                Math.cos(azimuth), //direction vector y
                azimuthDistance[1] * fovCorrection * sensitivity, azimuthDistance[0], //distance and azimut
                coords[0], coords[1]]; //coords

            this.coordsDeltas.push(forward);
            this.reduceFloatingHeight(0.9);

            if (config.legacyInertia) {
                this.updateDeltas(true);
            }

            this.browser.map.emit('map-position-panned', {});
        }
    } else if (((touches <= 1 && event.getDragButton('right')) || event.getDragButton('middle') || modifierKey)  && config.rotationAllowed) { //rotate

        sensitivity = config.sensitivity[1] * this.retinaFactor;
        this.orientationDeltas.push([delta[0] * sensitivity, -delta[1] * sensitivity, 0]);

        if (config.legacyInertia) {
            this.updateDeltas(false, true);
        }

        this.browser.map.emit('map-position-rotated', {});
    }
};


ControlModeMapObserver.prototype.wheel = function(event) {
    dom.preventDefault(event);

    var map = this.browser.getMap();
    if (!map || !this.config.zoomAllowed) {
        return;
    }

    if (map.getStats(true)['maxZoom']) {
        this.browser.config.minViewExtent = 0.5;
    }

    var camera = map.outerMap.camera;
    var delta = event.getWheelDelta();
    var sensitivity = this.config.sensitivity[2];

    if (this.browser.controlMode.shiftKey) sensitivity *= 0.1;

    var factor = 1.0 + (delta > 0 ? -1 : 1)*sensitivity;

    if (this.browser.controlMode.altKey &&
        this.browser.controlMode.shiftKey &&
        this.browser.controlMode.ctrltKey) {
        camera.set({ fovy: math.clamp(camera.fovy * factor, 1, 179) });
    } else {
        this.viewExtentDeltas.push(factor);
        this.reduceFloatingHeight(0.8);
        this.browser.map.emit('map-position-zoomed', {});
    }
};


ControlModeMapObserver.prototype.doubleclick = function(event) {
    dom.preventDefault(event);

    var map = this.browser.getMap();
    if (!map || !this.config.jumpAllowed) {
        return;
    }

    if (this.browser.controlMode.altKey &&
        this.browser.controlMode.shiftKey &&
        this.browser.controlMode.ctrlKey) {
        this.browser.config.minViewExtent = 0.5;
        return;
    }

    var coords = event.getMouseCoords();
    var canvasSize = this.browser.getRenderer().getCanvasSize();

    if (coords[0] < 0 || coords[1] < 0 || coords[0] >= canvasSize[0] || coords[1] >= canvasSize[1]) {
        return;
    }

    //get hit coords with the height measured from the datum
    var mapCoords = map.getHitCoords(coords[0], coords[1]);

    if (mapCoords) {
        var target = map.outerMap.camera.definition;
        target.center = [mapCoords[0], mapCoords[1]];
        target.altitudeRef = 'datum';
        target.altitude = mapCoords[2];

        if (this.browser.controlMode.shiftKey) {
            map.outerMap.camera.set(target);
        } else {
            this.browser.autopilot.flyTo(target,
                {'mode' : 'direct', 'maxDuration' : 2000 });
        }
    }
};


ControlModeMapObserver.prototype.up = function() {
    this.panning = false;
};


ControlModeMapObserver.prototype.keyup = function() {
};


ControlModeMapObserver.prototype.keydown = function() {
};


ControlModeMapObserver.prototype.keypress = function() {
};


// Keeps the camera within the configured limits after a change.
ControlModeMapObserver.prototype.applyLimits = function() {

    if (!this.config.walkMode) constrainCamera(this.browser);

    if (this.config.fixedHeight) {
        this.browser.getMap().outerMap.camera.set({
            altitude: this.config.fixedHeight,
        });
    }
};


ControlModeMapObserver.prototype.reduceFloatingHeight = function(factor) {
    var camera = this.browser.getMap().outerMap.camera;

    if (camera.altitudeRef == 'terrain' && camera.altitude != 0) {
        var altitude = camera.altitude * factor;

        if (Math.abs(altitude) < 0.1) {
            altitude = 0;
        }

        camera.set({ altitude: altitude });
        this.applyLimits();
    }
};


ControlModeMapObserver.prototype.isNavigationSRSProjected = function() {
    var map = this.browser.getMap();
    var rf = map.getReferenceFrame();
    var srs = map.getSrsInfo(rf['navigationSrs']);
    return (srs) ? (srs['type'] == 'projected') : false;
};


ControlModeMapObserver.prototype.getAzimuthAndDistance = function(dx, dy) {
    var camera = this.browser.getMap().outerMap.camera;
    var viewExtent = camera.viewExtent;
    var fov = camera.fovy*0.5;

    if (this.config.walkMode) {
        viewExtent += 5;
    }

    //var sensitivity = 0.5;
    var zoomFactor = (((viewExtent*0.5) * Math.tan(math.radians(fov))) / 800);
    dx *= zoomFactor;
    dy *= zoomFactor;

    var distance = Math.sqrt(dx*dx + dy*dy);
    var azimuth = -math.degrees(Math.atan2(dx, dy)) + camera.yaw;

    return [azimuth, distance];
};


ControlModeMapObserver.prototype.updateDeltas = function(onlyLastPan, onlyLastRotate, onlyLastZoom) {
    var map = this.browser.getMap();
    if (!map) {
        return;
    }

    var camera = map.outerMap.camera, delta, deltas;
    var update = false, azimuth, correction, i;
    var inertia = this.config.inertia, stats = map.getStats();
    var timeFactor = 1;
    var invTimeFactor = 1;

    if (this.config.timeNormalizedInertia) {
        var fps = (1000/(map.getStats()['frameTime'] + 0.000001));

        if (fps < 1) {
            fps = 60;
        }

        timeFactor = (fps/60);  //normalized to 60 fps
        invTimeFactor = 1.0/timeFactor;
    }

    //console.log(''+timeFactor);

    //process coords deltas
    if (!onlyLastRotate && !onlyLastZoom && this.coordsDeltas.length > 0) {
        deltas = this.coordsDeltas;
        var forward = [0,0];
        var coords = camera.center;

        //get foward vector form coord deltas
        for (i = (onlyLastPan ? (deltas.length - 1) : 0); i < deltas.length; i++) {
            delta = deltas[i];

            azimuth = delta[3];
            azimuth = math.radians(azimuth);

            forward[0] += Math.sin(azimuth) * (delta[2] * invTimeFactor);
            forward[1] += Math.cos(azimuth) * (delta[2] * invTimeFactor);

            delta[2] *= inertia[0] * timeFactor;

            //remove zero deltas
            if (delta[2] < 0.01) {
                deltas.splice(i, 1);
                i--;
            }
        }

        var distance = Math.sqrt(forward[0]*forward[0] + forward[1]*forward[1]);
        azimuth = math.degrees(Math.atan2(forward[0], forward[1]));

        if (!this.isNavigationSRSProjected()) {
            if (!this.northResetAnimation && this.config.navigationMode == 'azimuthal' && (Math.abs(coords[1]) > 75 || Math.abs(camera.yaw) > 1))  {
                this.config.navigationMode = 'azimuthal2';
            }
        }

        //apply final azimuth and distance
        correction = camera.yaw;
        camera.pan((this.isNavigationSRSProjected() ? -1 : 1) * azimuth, distance,
                   this.config.navigationMode == 'free'
                   || this.config.navigationMode == 'azimuthal2');
        correction = camera.yaw - correction;


        for (i = 0; i < deltas.length; i++) {
            delta = deltas[i];
            delta[3] += correction;
        }

        update = true;
    }

    //process coords deltas
    if (!onlyLastPan && !onlyLastZoom && this.orientationDeltas.length > 0) {
        deltas = this.orientationDeltas;
        var orientation = [camera.yaw, camera.pitch, camera.roll];

        //apply detals to current orientation
        for (i = (onlyLastRotate ? (deltas.length - 1) : 0); i < deltas.length; i++) {
            delta = deltas[i];
            orientation[0] += delta[0] * invTimeFactor;
            orientation[1] += delta[1] * invTimeFactor;
            orientation[2] += delta[2] * invTimeFactor;

            delta[0] *= inertia[1] * timeFactor;
            delta[1] *= inertia[1] * timeFactor;
            delta[2] *= inertia[1] * timeFactor;

            //remove zero deltas
            if (delta[0]*delta[0] + delta[1]*delta[1] + delta[2]*delta[2] < 0.1) {
                deltas.splice(i, 1);
                i--;
            }
        }

        //apply final orintation
        camera.set({
            yaw: orientation[0], pitch: orientation[1], roll: orientation[2],
        });
        update = true;
    }

    //process view extents deltas
    if (!onlyLastRotate && !onlyLastPan && this.viewExtentDeltas.length > 0) {
        deltas = this.viewExtentDeltas;
        var viewExtent = camera.viewExtent;

        //apply detals to current view extent
        for (i = (onlyLastZoom ? (deltas.length - 1) : 0); i < deltas.length; i++) {
            //viewExtent *= deltas[i];
            viewExtent *= Math.pow(deltas[i], invTimeFactor);
            deltas[i] += (1 - deltas[i]) * (1.0 - (inertia[2] * timeFactor));

            //deltas[i] *= Math.pow(deltas[i], Math.pow(inertia[2], timeFactor));

            //remove zero deltas
            if (Math.abs(1 - deltas[i]) < 0.001) {
                deltas.splice(i, 1);
                i--;
            }
        }

        viewExtent = Math.max(1, viewExtent);

        //apply final view extrent
        camera.set({ viewExtent: viewExtent });
        update = true;
    }

    //keep the camera within its limits
    if (update) this.applyLimits();
};

ControlModeMapObserver.prototype.tick = function() {
    this.updateDeltas();

    // a pan leaves the camera on the terrain reference; once the button
    // is released, the inertia has run out and the terrain under the
    // camera is settled, the altitude goes back to the datum, where a
    // zoom cannot move it
    var map = this.browser.getMap();
    if (!map) return;

    var camera = map.outerMap.camera;

    if (camera.altitudeRef == 'terrain' && !this.panning
            && this.coordsDeltas.length == 0 && camera.terrainSettled)
        camera.setAltitudeRef('datum');
};


ControlModeMapObserver.prototype.reset = function() {
    this.coordsDeltas = [];
    this.orientationDeltas = [];
    this.viewExtentDeltas = [];
};


// Keeps the map camera within the browser's configured limits.
function constrainCamera(browser) {
    if (!browser.config.constrainCamera) return;

    browser.getMap().outerMap.camera.constrain({
        minViewExtent: browser.config.minViewExtent,
        maxViewExtent: browser.config.maxViewExtent,
        tiltConstrainThreshold: browser.config.tiltConstrainThreshold,
    });
}


export {ControlModeMapObserver, constrainCamera};
